import React, { useContext, useEffect, useState } from 'react';
import css from './TagFilter.module.scss';
import { useContainerDimensions } from '../../hooks/useContainerDimension';
import { ReactComponent as IconMultiply } from '../../assets/icons/u_multiply.svg';
import { useDispatch, useSelector } from 'react-redux';
import { TagFilterContext } from '../../context/TagFilterContext';
import useFilters from '../../hooks/useFilters';
import { CalledFrom } from '../../models/CalledFromEnum';
import { getDivisionFilterOptions, getDivisionsFromSectors, updatedDivisions } from '../FilterV2/UtilFunctions';

export const TagFilter = ({ tag, calledFrom = CalledFrom.PORTFOLIO }) => {
  const {
    filter,
    filterIndicators,
    filterAnalytics,
    setFilter,
    setFilterIndicators,
    setFilterAnalytics,
    filterEarlyWarnings,
    setFilterEarlyWarnings,
  } = useFilters();
  const { containerRef } = useContainerDimensions(tag);
  const dispatch = useDispatch();
  const { deleteTagFromContext, optionsBySelect, labels } = useContext(TagFilterContext);
  const sectorsFromRedux = useSelector<any, any>(state => state.sectors);

  const [tagSelected, setTagSelected] = useState(null);
  const [pass, setPass] = useState({
    region: false,
    country: false,
    sector: false,
    division: false,
    responsibles: false,
    participants: false,
    leader: false,
    attribiute: false,
  });

  let newCountryArr: any = optionsBySelect;

  const deleteTag = tag => {
    setTagSelected(tag);
    deleteTagFromContext(tag);
    setPass({
      region: newCountryArr?.regions?.some(elem => elem.label === tag),
      country: newCountryArr?.country?.some(elem => elem.label === tag),
      sector: newCountryArr?.sector?.some(elem => elem.label === tag),
      division: newCountryArr?.division?.some(elem => elem.label === tag),
      responsibles: newCountryArr?.responsibles?.some(elem => elem.label === tag),
      participants: newCountryArr?.participants?.some(elem => elem.label === tag),
      leader: newCountryArr?.teamLeader?.some(elem => elem.label === tag),
      attribiute: newCountryArr?.Attributes?.some(elem => elem.label === tag),
    });
  };

  /**
   * funcióne que dispacha segun la condición al redux con los elementos eliminados.
   */

  const deletedFilterIndicator = (calledFrom) => {
    const dispatchAction = (key, value) => {
      switch (calledFrom) {
        case CalledFrom.PORTFOLIO:
          dispatch(
            setFilterIndicators({
              ...filterIndicators,
              common: {
                ...filterIndicators.common,
                [key]: value,
                ...(key === 'sectors' ? { divisionId: getDivisions(value) } : {})
              },
            }),
          );
          break;

        case CalledFrom.PROJECT:
          dispatch(
            setFilter({
              ...filter,
              common: {
                ...filter.common,
                [key]: value,
                itSearch: true,
                ...(key === 'sectors' ? { divisionId: getDivisionOptions(value) } : {})
              },
            }),
          );
          break;

        default:
          break;
      }
    };

    if (pass.region) {
      dispatchAction(
        'regionId',
        newCountryArr.regions
      );
    }
    if (pass.country) {
      dispatchAction(
        'countryId',
        newCountryArr.country
      );
    }
    if (pass.sector) {
      dispatchAction(
        'sectors',
        newCountryArr.sector
      );
    }

    if (pass.division) {
      dispatchAction(
        'divisionId',
        newCountryArr.division
      );
    }
    if (pass.responsibles) {
      dispatchAction(
        'coReponsibleDivisions',
        newCountryArr.responsibles
      );
    }
    if (pass.participants) {
      dispatchAction(
        'participantDivisions',
        newCountryArr.participants
      );
    }
    if (pass.leader) {
      dispatchAction(
        'teamLeaders',
        newCountryArr.teamLeader
      );
    }
    if (pass.attribiute) {
      dispatchAction(
        'interestIssues',
        newCountryArr.Attributes
      );
    }

    setPass({
      region: false,
      country: false,
      sector: false,
      division: false,
      responsibles: false,
      participants: false,
      leader: false,
      attribiute: false,
    });
  };

  const getDivisionOptions = (sectorsSelected) => {
    const divisions = getDivisionsFromSectors(sectorsSelected, sectorsFromRedux);
    return getDivisionFilterOptions(divisions);
  }

  const getDivisions = (sectorsSelected) => {
    const divisionOptions = getDivisionOptions(sectorsSelected);

    return updatedDivisions(sectorsSelected, filterIndicators, sectorsFromRedux).length !== 0 
        ? updatedDivisions(sectorsSelected, filterIndicators, sectorsFromRedux) 
        : divisionOptions
  }

  useEffect(() => {
    deletedFilterIndicator(calledFrom);
  }, [tagSelected]);

  return (
    <div ref={containerRef} className={css['c-tag-filter']}>
      <p>{tag}</p>
      <span onClick={() => deleteTag(tag)}>
        <IconMultiply />
      </span>
    </div>
  );
};
